import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Product } from '../../entity/api/product';
import { createBasicStoreState } from './basic-store';

type TModel = Product;
/**
 * Products Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from products-queries.ts:
 * - useProductsList()
 * - useProductById(id)
 * - useProductsByBrandId(brandId)
 * - useProductsByBulkGroupId(bulkGroupId)
 * - useProductSectionsByProductId(productId)
 * - useCreateProduct()
 * - useUpdateProduct()
 * - useUpdateProductBulk()
 * - useRemoveProduct()
 * - useRemoveProductBulk()
 * - useRetryProductGeneration()
 * - useExportProducts()
 *
 * For cache access, use helpers from products-queries.ts:
 * - getProductFromCache(queryClient, id)
 * - getProductsListFromCache(queryClient)
 * - getProductsByBrandIdFromCache(queryClient, brandId)
 * - getAdjacentProductIdFromCache(queryClient, direction, origin, brandId)
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'products' }
  )
);
